"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var createRecipientWell_1 = require("owa-readwrite-recipient-well/lib/utils/createRecipientWell");
/**
 * Maps people identity objects on an inbox rule to the edit page's recipient well view state, to prepopulate personas
 * @return the ReadWriteRecipientWellViewState populated with the PeopleIdentities as personas
 */
function mapPeopleIdentityToReadWriteRecipientWellViewState(peopleIdentity) {
    // map conditional clauses
    var initialMailboxes = [];
    for (var _i = 0, peopleIdentity_1 = peopleIdentity; _i < peopleIdentity_1.length; _i++) {
        var identity = peopleIdentity_1[_i];
        var mailbox = {
            Name: identity.DisplayName,
            EmailAddress: identity.SmtpAddress,
            RoutingType: identity.RoutingType,
        };
        initialMailboxes.push(mailbox);
    }
    return createRecipientWell_1.default(initialMailboxes);
}
exports.default = mapPeopleIdentityToReadWriteRecipientWellViewState;
//# sourceMappingURL=mapPeopleIdentityToReadWriteRecipientWellViewState.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/mapPeopleIdentityToReadWriteRecipientWellViewState.js
// module id = 3385
// module chunks = 2 90